module.exports = __webpack_public_path__ + "img/user-guide-03-02.91a68f97.png";